import { AsyncPipe, NgClass } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Entities } from '../../../data-rules-model';
import { MetaDataService, MetaSource } from '../../../meta-data.service';
import { CustomOverlayForDirective, ICustomPositioningConfig } from '../../custom-component-overlay.directive';
import { IEntityItem } from '../paired-autocomplete.component';
import { EntitySelectComponent } from './entity-select/entity-select.component';

@Component({
  selector: 'app-entity-picker',
  templateUrl: './entity-picker.component.html',
  styleUrls: ['./entity-picker.component.scss'],
  imports: [
    NgClass,
    CustomOverlayForDirective,
    AsyncPipe,
    EntitySelectComponent
  ]
})
export class EntityPickerComponent implements OnInit, AfterViewInit {
  @Input() descriptorControl: FormControl;
  @Input() entities: IEntityItem[];
  @Input() primaryEntity: Entities;
  @Input() dataSourceType: MetaSource = MetaSource.DATA_SOURCE;

  @Input() overlayPositioningConfig: ICustomPositioningConfig;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onToggle = new EventEmitter<boolean>();
  @ViewChild('selectionBox') selectionBox;

  entitySelectorsMap: any;

  selectedEntityDescriptor: string | null;
  selectedEntityName: string;
  selectedIcon: EventEmitter<string> = new EventEmitter<string>(true);

  constructor(private metaDataService: MetaDataService) {
  }

  ngOnInit() {
    this.entitySelectorsMap = this.metaDataService.getEntitiesSelectorsMap();

    this.descriptorControl.valueChanges.subscribe(value => {
      this.selectedEntityDescriptor = value;
      if (value) {
        this.metaDataService.getEntityNameFromSecondaryDescriptor(this.primaryEntity, value, this.dataSourceType).subscribe(({entity}) => {
          this.updateSelectedName(entity, value);
        });
      } else {
        this.updateSelectedName(this.primaryEntity);
      }
    }, error => {
      console.error(error);
    });
  }

  ngAfterViewInit() {
    const secondaryDescriptor = this.descriptorControl.value;
    this.selectedEntityDescriptor = secondaryDescriptor;
    this.metaDataService.getEntityNameFromSecondaryDescriptor(this.primaryEntity, this.selectedEntityDescriptor, this.dataSourceType)
      .subscribe(({entity}) => {
        this.updateSelectedName(entity, secondaryDescriptor);
      }, error => {
        console.error(error);
      });
  }

  public isSelected(entity: IEntityItem): boolean {

    const secondaryDescriptor = this.descriptorControl.value;
    const isSelectedEntityActual = secondaryDescriptor === entity.secondaryDescriptor;
    return isSelectedEntityActual;
  }

  updateSelectedName(entityName: string, secondaryDescriptor?: string) {
    this.selectedEntityName = secondaryDescriptor ? `${entityName}-${secondaryDescriptor}` : entityName;
    this.selectedIcon.emit(this.renderIcon(this.entitySelectorsMap[entityName] || entityName));
  }

  shouldEntityPickerClose(): boolean {
    return true;
  }

  renderIcon(entity: string): string {
    const defaultNames = () => {
      if (entity.includes('candidate'))
        return 'bhi-candidate';
      if (entity.includes('contact') || entity.includes('person'))
        return 'bhi-person';
      if (entity.includes('client-corporation'))
        return 'bhi-company';
      if (entity.includes('submission'))
        return 'bhi-job submission';
      if (entity.includes('job'))
        return 'bhi-job';
      if (entity.includes('lead'))
        return 'bhi-lead';
      if (entity.includes('opportunity'))
        return 'bhi-opportunity';
      if (entity.includes('placement'))
        return 'bhi-star';
      if (entity.includes('appointment'))
        return 'bhi-appointment';
      if (entity.includes('task'))
        return 'bhi-check-o';
      if (entity.includes('note'))
        return 'bhi-add-note';
      if (entity.includes('sendout'))
        return 'bhi-email';
      if (entity.includes('corporate-user'))
        return 'bhi-user';
      if (entity.includes('tearsheet'))
        return 'bhi-tearsheet';
      return 'bhi-puzzle';
    };
    const defaultName = defaultNames();
    return entity.includes('custom-object')
      // todo hardcoded
      || entity === 'person'
      ? `${defaultName} custom-object` : defaultName;
  }

}
